import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import {
  CardRow,
  StructureSection,
} from "../OpenBoxQuotes/BoxStructureFields";
import { NumberedSectionTitle } from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";
import {
  FRONT_WALL,
  NoteCard,
  REAR_FRAME,
  REAR_OPENING,
  ROOF_BEAM,
  ROOF_TYPE,
  roofKey,
  SideDoorsCard,
  TypeCard,
} from "./BoxStructureCards";

const BoxStructure = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={3}
        titleKey={formKey("SECTIONS.BOX_STRUCTURE")}
      />

      <StructureSection titleKey={roofKey("SECTIONS.ROOF")} plain>
        <CardRow columns={3}>
          <TypeCard cardKey="roofType" options={ROOF_TYPE} />
          <NoteCard cardKey="hydraulicRoof" />
          <NoteCard cardKey="detachableRoof" />
        </CardRow>
        <CardRow columns={2}>
          <TypeCard cardKey="longitudinalBeams" options={ROOF_BEAM} />
          <NoteCard cardKey="middlePillar" />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={roofKey("SECTIONS.WALLS_AND_DOORS")}>
        <CardRow columns={3}>
          <TypeCard cardKey="frontWall" options={FRONT_WALL} />
          <TypeCard cardKey="rearFrame" options={REAR_FRAME} />
          <TypeCard cardKey="rearOpening" options={REAR_OPENING} />
        </CardRow>
        <CardRow columns={3}>
          <NoteCard cardKey="hydraulicSide" />
          <NoteCard cardKey="sideCompletionFlap" />
          <SideDoorsCard />
        </CardRow>
        <CardRow columns={2}>
          <NoteCard cardKey="sidePillars" />
          <NoteCard cardKey="plywoodInsteadOfCurtain" />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={roofKey("SECTIONS.CURTAINS")}>
        <CardRow columns={2}>
          <NoteCard cardKey="curtainTypeAndTensioners" />
          <NoteCard cardKey="tensionType" />
        </CardRow>
        <CardRow columns={2}>
          <NoteCard cardKey="curtainRail" />
          <NoteCard cardKey="curtainEdge" />
        </CardRow>
      </StructureSection>
    </Box>
  );
};

export default BoxStructure;
